import { Accept } from 'react-dropzone';
import { IInfoAreaEntitySource } from '@fw-nextgen/fw-components';
import { FieldType } from '@app/src/common/components/form/MobxFieldControl';
import { FormControlType } from '@app/src/common/model/FormControls';
import { FormValidator } from '@app/src/common/model/FormValidator';

export interface ISelectOption {
  value: string | number;
  label: string;
  disabled?: boolean;
  option?: any;
}

export interface IMultiSelectOption {
  value: string;
  label: string;
  subLabel?: string;
  item?: any;
}

export interface IFilterItem {
  name: string;
  value: any;
  isAsset?: boolean;
}

export enum FilterCondition {
  AND = 'and',
  OR = 'or'
}

export interface IFormField {
  name: string;
  label: string;
  type: FieldType;
  control: FormControlType;
  dbName?: string; // use in case different controls for one db field (See PG L-SelfReg for examle)

  required?: boolean;
  defaultValue?: any;
  validators?: IValidator[];

  isInfoField?: boolean; // used for determine Label, Header, Info
  serviceField?: boolean; // used for specific case, see example in PG visitor
  isAsset?: boolean;

  sourceType?: SourceType;
  sourceName?: string;
  sourceDependOn?: ISourceDependence;

  dependOn?: IDependence;

  prefill?: IPrefill;
  prefillOnly?: boolean; // use only for prefill, hide on form

  fields?: IFormField[]; // for FieldType.LAYOUT

  props?: {
    [key: string]:
      | string
      | ISelectOption[]
      | boolean
      | Accept
      | number
      | IInfoAreaEntitySource;
  };

  restriction?: IRestriction;
}

export enum SourceType {
  DB = 'db',
  DICTIONARY = 'dictionary'
}

export interface IValidator {
  type: FormValidator;
  value?: string | number | RegExp;
  message?: string;
  props?: Record<string, string>;
}

export interface IDependence {
  field: string;
  type?: DependenceType;
  value: any;
  condition?: ConditionType;
  rule?: DependenceRule;
  excludedWeekDays?: number[]; // for ConditionType.TIME_PERIOD only
  excludedValue?: string[];
}

export interface ISourceDependence {
  field: string;
  paramName: string;
}

export interface IPrefill {
  type: PrefillType;
  field: string; // FORM_CONTROL: the source control
  matchField?: string; // FORM_CONTROL: attribute of the selected option(s) of the source dictionary
  sourceName?: string;
  matchValue?: any; // FORM_CONTROL: value(s) to match; when set, the field gets `value` or its defaultValue
  value?: any; // FORM_CONTROL: value written when `matchValue` matched
}

export enum PrefillType {
  CURRENT_USER = 'currentUser',
  OFFICE_USER = 'officeUser', // for platform officeUser = currentUser
  // recalculated on every change of the source control, not only on a new form
  FORM_CONTROL = 'formControl'
}

export enum DependenceType {
  HIDE = 'hide',
  DISABLE = 'disable',
  REQUIRED = 'required'
}

export enum DependenceRule {
  EQUAL = 'equal',
  NOT_EQUAL = 'notEqual',
  LESS = 'less'
}

export enum ConditionType {
  EMPTY = 'empty',
  NOT_EMPTY = 'notEmpty',
  TIME_PERIOD = 'timePeriod',
  EDIT = 'edit'
}

export interface IRestriction {
  type: RestrictionType;
  role: string;
  condition: RestrictionCondition;
}

export enum RestrictionType {
  EDIT = 'edit',
  VIEW = 'view'
}

export enum RestrictionCondition {
  INCLUDE = 'include',
  EXCLUDE = 'exclude'
}
